import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';
import WhatsAppButton from '../../components/ui/WhatsAppButton/WhatsAppButton';
import Seo from '../../components/utils/Seo';
import Hero from '../../sections/Hero/Hero';
import MarqueeSection from '../../sections/Marquee/MarqueeSection';
import Projects from '../../sections/Projects/Projects';
import CtaBand from '../../sections/CtaBand/CtaBand';
import Contact from '../../sections/Contact/Contact';

export default function LandingPage() {
  return (
    <>
      <Seo
        title="NimbleCasa — Premium Real Estate in Lagos"
        description="NimbleCasa develops modern, premium residential communities across Lagos — quality construction, thoughtful design, and strong investment returns."
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <MarqueeSection />
        <Projects />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
